const forge = require("node-forge");

module.exports = {
  
  id: () => {
    return forge.util.bytesToHex( forge.random.getBytesSync(8) );
  },
  
  
  
}